export class PolylineSimplifier {
    constructor(tolerance = PolylineSimplifier.DEFAULT_TOLERANCE, highestQuality = false) {
        this._tolerance = tolerance;
        this._highestQuality = highestQuality;
    }
    simplify(points, tolerance, highestQuality) {
        if (points.length <= 2)
            return points;
        const toleranceValue = tolerance ?? this._tolerance;
        const highestQualityValue = highestQuality ?? this._highestQuality;
        points = highestQualityValue ? points : this._simplifyDouglasPeucker(points, toleranceValue);
        return this._simplifyRadialDist(points, this._tolerance);
    }
    _simplifyRadialDist(points, sqTolerance) {
        let prevPoint = points[0], newPoints = [prevPoint], point = prevPoint;
        for (var i = 1, len = points.length; i < len; i++) {
            point = points[i];
            if (this._getSqDist(point, prevPoint) > sqTolerance) {
                newPoints.push(point);
                prevPoint = point;
            }
        }
        if (prevPoint !== point)
            newPoints.push(point);
        return newPoints;
    }
    _simplifyDouglasPeucker(points, sqTolerance) {
        var last = points.length - 1;
        var simplified = [points[0]];
        this._simplifyDPStep(points, 0, last, sqTolerance, simplified);
        simplified.push(points[last]);
        return simplified;
    }
    _getSqDist(p1, p2) {
        var dx = p1.x - p2.x, dy = p1.y - p2.y;
        return dx * dx + dy * dy;
    }
    _getSqSegDist(p, p1, p2) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y;
        if (dx !== 0 || dy !== 0) {
            var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            }
            else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return dx * dx + dy * dy;
    }
    _simplifyDPStep(points, first, last, sqTolerance, simplified) {
        var maxSqDist = sqTolerance, index;
        for (var i = first + 1; i < last; i++) {
            var sqDist = this._getSqSegDist(points[i], points[first], points[last]);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            if (index - first > 1)
                this._simplifyDPStep(points, first, index, sqTolerance, simplified);
            simplified.push(points[index]);
            if (last - index > 1)
                this._simplifyDPStep(points, index, last, sqTolerance, simplified);
        }
    }
}
PolylineSimplifier.DEFAULT_TOLERANCE = 1;
PolylineSimplifier.Shared = new PolylineSimplifier();
//# sourceMappingURL=geometry.simplify.js.map